import ProductBundleOption from 'Component/ProductBundleOption';
import {
    ProductBundleOptions as SourceProductBundleOptions
} from 'SourceComponent/ProductBundleOptions/ProductBundleOptions.component';

import './ProductBundleOptions.override.style';

/** @namespace Elganso/Component/ProductBundleOptions/Component */
export class ProductBundleOptionsComponent extends SourceProductBundleOptions {
    renderOptionGroup(group) {
        const {
            title,
            options,
            type,
            required,
            uid,
            option_id
        } = group;

        const { product, updateSelectedValues } = this.props;

        return (
            <ProductBundleOption
              key={ option_id }
              title={ title }
              options={ options }
              type={ type }
              isRequired={ required }
              required={ required }
              updateSelectedValues={ updateSelectedValues }
              uid={ uid }
              product={ product }
            />
        );
    }
}

export default ProductBundleOptionsComponent;
